import { render, staticRenderFns } from "./moduleStructureBeneficiary.vue?vue&type=template&id=037b87e0"
import script from "./moduleStructureBeneficiary.vue?vue&type=script&lang=js"
export * from "./moduleStructureBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports